import { weekdayNames } from 'shared/util/calendar';

type WeekdayHeaderProps = {
    offsetStartDay?: number;
};

export const WeekdayHeader = ({ offsetStartDay = 1 }: WeekdayHeaderProps) => {
    const weekdayNamesArr = [...weekdayNames];

    for (let i = 0; i < offsetStartDay; i++) {
        const weekdayName: string = weekdayNamesArr.shift() ?? '';

        weekdayNamesArr.push(weekdayName);
    }

    return (
        <>
            {weekdayNamesArr.map((weekdayName) => (
                <h3 className="Calendar-columnTitleItem" key={weekdayName}>
                    <abbr className="Calendar-columnTitleText" title={weekdayName}>
                        {weekdayName.slice(0, 3)}
                    </abbr>
                </h3>
            ))}
        </>
    );
};
